import Vue from "vue";
import VueCurrencyFilter from "vue-currency-filter";
import VueApexCharts from "vue-apexcharts";
import VueCookies from 'vue-cookies'

import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import AuthService from "@/modules/auth";
import vuetify from "@/plugins/vuetify";
import "@/plugins/moment";
import "@/plugins/localforage";
import "@/plugins/element-ui";
import "@/plugins/ml";

// directives
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

const IS_PRODUCTION = process.env.NODE_ENV === "production";
const SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN;

// Configure Vue global options, see https://vuejs.org/v2/api/#Global-Config

// Enable perf timeline measuring for Vue components in Chrome Dev Tools
// Note: this has been disabled because it caused some perf issues
// if rendering becomes too slow in dev mode, we should turn it off
// See https://github.com/vuejs/vue/issues/5174
Vue.config.performance = !IS_PRODUCTION;
// Disable annoying reminder abour production build in dev mode
Vue.config.productionTip = IS_PRODUCTION;
Vue.config.devtools = true;
if (IS_PRODUCTION && SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  });
}

Vue.use(VueCurrencyFilter, {
  symbol: "₽",
  thousandsSeparator: " ",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "back",
  symbolSpacing: true,
  avoidEmptyDecimals: undefined
});

Vue.use(AuthService);

import VueNativeSock from "vue-native-websocket";
Vue.use(
  VueNativeSock,
  process.env.VUE_APP_WS_API_URL,
  { format: "json", connectManually: true }
);

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

Vue.use(VueCookies);
Vue.$cookies.set("lang", process.env.VUE_APP_LANG)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
